import type { Resources } from './en';

export const ro: Resources = {
  app: { name: 'Streamline Engineering' },
  lang: { ro: 'Română', en: 'English', label: 'Limbă' },
  auth: {
    signIn: 'Autentificare',
    signOut: 'Deconectare',
    sessionEnded: 'Sesiunea ta s-a încheiat.',
    signingIn: 'Se autentifică…',
  },
  roles: { admin: 'Administrator', user: 'Utilizator' },
  nav: {
    myServices: 'Beneficiari',
    search: 'Căutare',
    tenantAdmin: 'Administrare organizație',
    dashboard: 'Panou',
    members: 'Membri',
    forms: 'Formulare',
    services: 'Servicii',
    instances: 'Beneficiari',
    templates: 'Șabloane de documente',
    audit: 'Jurnal de audit',
    platform: 'Platformă',
    tenants: 'Organizații',
    catalog: 'Catalog implicit',
    globalAudit: 'Audit global',
    import: 'Import',
  },
  common: {
    results: '{{count}} rezultat(e)',
    nothingHere: 'Momentan nu există nimic aici.',
    loading: 'Se încarcă…',
    cancel: 'Anulează',
    create: 'Creează',
    start: 'Începe',
    submit: 'Trimite',
    update: 'Actualizează',
    download: 'Descarcă',
    saving: 'Se salvează…',
    savedDraft: 'Ciornă salvată',
    unsaved: 'Modificări nesalvate',
    somethingWrong: 'A apărut o problemă',
    codeLabel: 'Cod: {{code}}',
    name: 'Nume',
    status: 'Stare',
    updated: 'Actualizat',
    origin: 'Origine',
    type: 'Tip',
    version: 'Versiune',
    email: 'Email',
    role: 'Rol',
    title: 'Titlu',
    reference: 'Referință',
    created: 'Creat',
    joined: 'Membru din',
    tenant: 'Organizație',
    platformDefault: 'Implicit al platformei',
    service: 'Serviciu',
    copied: 'Copiat',
    archive: 'Arhivează',
    unarchive: 'Dezarhivează',
    archived: 'Arhivat',
    actions: 'Acțiuni',
  },
  status: {
    ACTIVE: 'activ',
    DRAFT: 'ciornă',
    PUBLISHED: 'publicat',
    ARCHIVED: 'arhivat',
    SUSPENDED: 'suspendat',
    OPEN: 'deschis',
    IN_PROGRESS: 'în lucru',
    COMPLETED: 'finalizat',
    CANCELLED: 'anulat',
    SUBMITTED: 'trimis',
    VALIDATED: 'validat',
    REJECTED: 'respins',
    EXPIRED: 'expirat',
    REVOKED: 'revocat',
    QUEUED: 'în așteptare',
    PROCESSING: 'în procesare',
    FAILED: 'eșuat',
    CONSUMED: 'consumat',
    PENDING: 'în așteptare',
    INDEXED: 'indexat',
  },
  myServices: {
    title: 'Beneficiari',
    startService: 'Adaugă Beneficiar',
    filterPlaceholder: 'Filtrează după titlu sau referință',
    all: 'Toate',
    open: 'Deschise',
    active: 'În lucru',
    completed: 'Finalizate',
    reference: 'Referință',
    titleCol: 'Titlu',
    statusCol: 'Stare',
    created: 'Creat',
    completedCol: 'Finalizat',
    empty: 'Momentan niciun beneficiar — folosește „Adaugă Beneficiar” pentru a adăuga primul.',
    startTitle: 'Adaugă Beneficiar',
    chooseService: 'Alege un serviciu',
    caseTitle: 'Dă un titlu cazului tău',
    noServices: 'Nu există servicii publicate disponibile',
  },
  instance: {
    forms: 'Formulare',
    shareLinks: 'Linkuri de partajare',
    documents: 'Documente',
    markCompleted: 'Marchează finalizat',
    cancelService: 'Anulează serviciul',
    createdOn: 'creat {{date}}',
    completedOn: 'finalizat {{date}}',
    submitted: 'trimis {{date}}',
    required: 'obligatoriu',
    externalNote: 'Acest formular se completează extern, printr-un link de partajare.',
    validate: 'Validează',
    reject: 'Respinge',
    serviceCompletedTitle: 'Serviciu finalizat',
    serviceCancelledTitle: 'Serviciu anulat',
    reopenedTitle: 'Redeschis pentru editare',
    reopenedMessage: 'Formularele pot fi editate din nou, actualizate la ultima versiune.',
    reopenForEditing: 'Redeschide pentru editare',
    archive: 'Arhivează cazul',
    edit: 'Editează',
    unarchive: 'Dezarhivează',
    archivedTitle: 'Caz arhivat',
    unarchivedTitle: 'Caz dezarhivat',
    comments: 'Comentarii',
    compositionUnavailable: 'Componența serviciului este indisponibilă.',
    outputTemplate: 'Șablon de document',
    noTemplatesYet: 'Niciun șablon definit încă',
    chooseTemplate: 'Alege un șablon',
    generateDocument: 'Generează document',
    colTemplate: 'Șablon',
    colStatus: 'Stare',
    colRequested: 'Solicitat',
    colCompleted: 'Finalizat',
    noDocumentsYet: 'Niciun document generat încă.',
    draftConflictTitle: 'Ciornă modificată în altă parte',
    draftConflictMessage: 'Această ciornă a fost actualizată în altă fereastră. Reîncarcă pentru a continua.',
    fixHighlighted: 'Te rugăm să corectezi câmpurile evidențiate.',
    submittedTitle: 'Trimis',
    submittedMessage: '{{name}} a fost trimis.',
    completionMode_INTERNAL: 'Intern',
    completionMode_EXTERNAL: 'Extern',
    completionMode_BOTH: 'Intern și extern',
    noExternalForms: 'Niciun formular completabil extern în acest serviciu.',
    colForm: 'Formular',
    linkRecipientHint: 'Destinatarul poate redeschide linkul pentru a-și actualiza răspunsurile',
    createShareLink: 'Creează link de partajare',
    linkCreatedTitle: 'Link creat — copiază-l acum, este afișat o singură dată',
    copy: 'Copiază',
    copied: 'Copiat',
    colSubmissions: 'Trimiteri',
    colExpires: 'Expiră',
    colCreated: 'Creat',
    revoke: 'Revocă',
    noShareLinksYet: 'Niciun link de partajare încă.',
  },
  publicForm: {
    progressSaved: 'Progresul este salvat automat',
    thankYou: 'Îți mulțumim!',
    submittedOk: 'Formularul a fost trimis cu succes.',
    confirmation: 'Confirmare: {{id}}',
    unavailable: 'Indisponibil',
    linkInvalid: 'Acest link nu este valid.',
    linkExpired: 'Acest link a expirat. Solicită unul nou persoanei de contact.',
    linkRevoked: 'Acest link nu mai este disponibil.',
    linkConsumed: 'Acest formular a fost deja trimis.',
    alreadySubmitted: 'Ai trimis deja acest formular — îl poți actualiza mai jos.',
    saved: 'Salvat.',
    noLongerAvailable: 'Acest formular nu mai este disponibil.',
    fixHighlighted: 'Vă rugăm să corectați câmpurile evidențiate.',
    uploadFailed: 'Încărcarea a eșuat',
  },
  publicService: {
    intro: 'Completează formularul (formularele) de mai jos pentru a-ți trimite solicitarea. Apasă Începe când ești gata.',
    saveContinue: 'Salvează și continuă',
    thankYou: 'Îți mulțumim!',
    complete: 'Solicitarea ta a fost trimisă.',
  },
  validation: {
    REQUIRED: 'Acest câmp este obligatoriu',
    INVALID_TYPE: 'Valoare invalidă',
    INVALID_EMAIL: 'Format de email invalid',
    INVALID_PHONE: 'Număr de telefon invalid',
    INVALID_DATE: 'Introdu o dată validă (AAAA-LL-ZZ)',
    MIN_LENGTH: 'Minim {{min}} caractere',
    MAX_LENGTH: 'Maxim {{max}} caractere',
    PATTERN: 'Valoarea nu respectă formatul cerut',
    MIN_VALUE: 'Valoarea minimă este {{min}}',
    MAX_VALUE: 'Valoarea maximă este {{max}}',
    MIN_DATE: 'Data trebuie să fie cel devreme {{minDate}}',
    MAX_DATE: 'Data trebuie să fie cel târziu {{maxDate}}',
    INVALID_OPTION: 'Alege o opțiune validă',
    DUPLICATE_OPTION: 'Nu sunt permise selecții duplicate',
    MIN_SELECTIONS: 'Selectează cel puțin {{min}} opțiune(i)',
    MAX_SELECTIONS: 'Selectează cel mult {{max}} opțiune(i)',
    INVALID_ADDRESS: 'Te rugăm să alegi o adresă',
    INVALID_BARCODE: 'Format de cod de bare invalid',
    MAX_FILES: 'Sunt permise cel mult {{max}} fișier(e)',
    MAX_FILE_SIZE: 'Fișierul este prea mare',
    INVALID_MIME_TYPE: 'Acest tip de fișier nu este permis',
    UNKNOWN_FILE: 'Fișierul referit nu a fost găsit',
    DUPLICATE_FILE: 'Același fișier a fost atașat de mai multe ori',
    default: 'Valoare invalidă',
  },
  shell: {
    tenantSelector: 'Organizație',
  },
  dashboard: {
    openServices: 'Servicii deschise',
    inProgress: 'În desfășurare',
    completed: 'Finalizate',
    serviceTemplates: 'Șabloane de serviciu',
  },
  audit: {
    when: 'Când',
    action: 'Acțiune',
    resource: 'Resursă',
    actor: 'Autor',
    ip: 'IP',
    noEntries: 'Nicio intrare de audit nu corespunde.',
    filterPlaceholder: 'Filtrează după prefixul acțiunii (ex. form.)',
  },
  forms: {
    newForm: 'Formular nou',
    createTitle: 'Creează un formular',
    createAndOpen: 'Creează și deschide editorul',
  },
  services: {
    newService: 'Serviciu nou',
    shareLink: 'Link de partajare',
    shareLinkTitle: 'Link de partajare a serviciului',
    shareLinkInfo:
      'Oricine are acest link poate deschide un caz nou al acestui serviciu și poate completa formularele sale externe. Copiază-l acum — este afișat o singură dată.',
    copyLink: 'Copiază linkul',
    createTitle: 'Creează un serviciu',
    createAndConfigure: 'Creează și configurează',
  },
  instances: {
    searchPlaceholder: 'Caută după titlu sau referință',
    allStatuses: 'Toate stările',
    newInstance: 'Beneficiar nou',
    createTitle: 'Adaugă un beneficiar',
  },
  members: {
    invite: 'Invită membru',
    invitationSent: 'Invitație trimisă',
    deactivate: 'Dezactivează',
    activate: 'Activează',
    inviteTitle: 'Invită un membru',
    emailPlaceholder: 'persoana@exemplu.com',
    firstName: 'Prenume',
    inviteHint: 'Persoana se autentifică cu contul organizației sale; apartenența este asociată prin email.',
    sendInvitation: 'Trimite invitația',
  },
  templates: {
    newTemplate: 'Șablon nou',
    archive: 'Arhivează',
    empty: 'Încă nu există șabloane — creează unul pentru a genera documente din serviciile finalizate.',
    createTitle: 'Creează un șablon de document',
    typeHtml: 'HTML (șablon Liquid)',
    typeDocx: 'Document Word (.docx cu substituenți)',
    typeCsv: 'CSV + atașamente (ZIP)',
    templateHtml: 'HTML-ul șablonului',
    placeholderHelp:
      'Substituenți: {{ref}}, {{title}}, {{tenant}}, {{field}} sau {{fieldShort}} pentru orice câmp trimis.',
    uploadDocx: 'Încarcă șablon .docx',
    uploadDocxFirst: 'Încarcă mai întâi un fișier șablon .docx.',
    csvInfo: 'Exportă toate datele trimise ca export.csv plus fiecare fișier încărcat în /files.',
    createTemplate: 'Creează șablonul',
  },
  builder: {
    addField: 'Adaugă câmp',
    fieldType: {
      text: 'Text',
      textarea: 'Zonă de text',
      number: 'Număr',
      email: 'Email',
      phone: 'Telefon',
      checkbox: 'Casetă de bifat',
      date: 'Dată',
      address: 'Adresă',
      barcode: 'Cod de bare',
      dropdown: 'Listă derulantă',
      radio: 'Buton radio',
      multiselect: 'Selecție multiplă',
      file: 'Fișier',
    },
    dragField: 'Trage {{label}}',
    deleteField: 'Șterge {{label}}',
    visibleWhen: 'Vizibil când',
    requiredWhen: 'Obligatoriu când',
    fieldSettings: 'Setări câmp',
    fieldId: 'ID câmp',
    label: 'Etichetă',
    description: 'Descriere',
    placeholder: 'Text substituent',
    required: 'Obligatoriu',
    searchable: 'Poate fi căutat',
    searchableDesc: 'Valoarea este indexată pentru căutare',
    options: 'Opțiuni',
    validation: 'Validare',
    minLength: 'Lungime minimă',
    maxLength: 'Lungime maximă',
    pattern: 'Model (regex)',
    patternMessage: 'Mesaj pentru model',
    min: 'Minim',
    max: 'Maxim',
    minDate: 'Dată minimă',
    maxDate: 'Dată maximă',
    allowedMimeTypes: 'Tipuri MIME permise',
    maxFileSize: 'Dimensiune maximă fișier (octeți)',
    maxFiles: 'Număr maxim de fișiere',
    minSelections: 'Selecții minime',
    maxSelections: 'Selecții maxime',
    barcodeFormats: 'Formate cod de bare',
    conditionalLogic: 'Logică condițională',
    mime: {
      pdf: 'PDF (application/pdf)',
      png: 'Imagine PNG (image/png)',
      jpeg: 'Imagine JPEG (image/jpeg)',
      webp: 'Imagine WebP (image/webp)',
      plain: 'Text simplu (text/plain)',
      csv: 'CSV (text/csv)',
      docx: 'Word (.docx)',
      xlsx: 'Excel (.xlsx)',
      pptx: 'PowerPoint (.pptx)',
      doc: 'Word 97-2003 (.doc)',
    },
    conditionFieldPlaceholder: 'Câmp',
    conditionValuePlaceholder: 'Valoare',
    condFieldAria: '{{title}}: câmp',
    condOperatorAria: '{{title}}: operator',
    condValueAria: '{{title}}: valoare',
    op: {
      equals: 'egal cu',
      notEquals: 'diferit de',
      contains: 'conține',
      greaterThan: 'mai mare decât',
      lessThan: 'mai mic decât',
      isEmpty: 'este gol',
      isNotEmpty: 'nu este gol',
    },
    optionN: 'Opțiune {{n}}',
    optionValueAria: 'Valoare opțiune {{n}}',
    optionLabelAria: 'Etichetă opțiune {{n}}',
    removeOptionAria: 'Elimină opțiunea {{n}}',
    valuePlaceholder: 'valoare',
    labelPlaceholder: 'etichetă',
    addOption: 'Adaugă opțiune',
    schemaProblems: 'Probleme cu schema',
    confirmDelete: 'Ștergi câmpul „{{label}}” ({{id}})?',
    noFieldsYet: 'Niciun câmp încă. Adaugă unul din paleta din stânga.',
    selectFieldToConfigure: 'Selectează un câmp pentru a-l configura.',
    published: 'Publicat',
    formVersionLive: 'Versiunea formularului este acum activă.',
    serviceVersionLive: 'Versiunea serviciului este activă.',
    platformDefault: 'Implicit de platformă',
    platformDefaultReadonly: 'Implicit de platformă (doar citire)',
    publishVersion: 'Publică versiunea',
    saveDraft: 'Salvează ciorna',
    tabBuilder: 'Constructor',
    tabPreview: 'Previzualizare',
    tabVersions: 'Versiuni',
    livePreview: 'Previzualizare live — exact ce vor vedea utilizatorii, inclusiv logica condițională.',
    colVersion: 'Versiune',
    colStatus: 'Stare',
    colFields: 'Câmpuri',
    colCreated: 'Creat',
    colPublished: 'Publicat',
    addPublishedForm: 'Adaugă un formular publicat',
    noMoreForms: 'Nu mai există formulare publicate disponibile',
    pickForm: 'Alege un formular',
    addForm: 'Adaugă formular',
    colOrder: 'Ordine',
    colForm: 'Formular',
    colCompletion: 'Completare',
    updateToLatest: 'Actualizează la ultima versiune',
    completionInternal: 'Intern',
    completionExternal: 'Extern (link)',
    completionBoth: 'Ambele',
    addFormEmpty: 'Adaugă cel puțin un formular publicat la acest serviciu.',
  },
  renderer: {
    address: {
      manualPlaceholder: 'Introduceți adresa',
      searchPlaceholder: 'Căutați o adresă',
      searchUnavailable: 'Căutarea adreselor nu este disponibilă aici — introduceți adresa manual.',
      noMatches: 'Niciun rezultat găsit.',
      clear: 'Șterge adresa',
      pickOnMap: 'Alege pe hartă',
      reverseLookup: 'Se caută adresa pentru punctul selectat…',
    },
    barcode: {
      scan: 'Scanează',
      scanTitle: 'Scanează codul de bare',
      cameraDenied: 'Accesul la cameră a fost refuzat. Permiteți accesul la cameră în browser sau introduceți codul manual.',
      cameraNotFound: 'Nu a fost găsită nicio cameră utilizabilă pe acest dispozitiv. Puteți introduce codul manual.',
      cameraInUse: 'Camera este deja folosită de o altă aplicație. Puteți introduce codul manual.',
      cameraUnavailable: 'Scanarea cu camera nu este disponibilă în acest browser. Puteți introduce codul manual.',
      cameraNotSupported: 'Scanarea cu camera nu este acceptată în acest browser. Puteți introduce codul manual.',
      noCamera: 'Nu a fost găsită nicio cameră pe acest dispozitiv. Puteți introduce codul manual.',
      cameraUnavailableTitle: 'Cameră indisponibilă',
      cameraLabel: 'Cameră',
      cameraNumber: 'Camera {{number}}',
      pointHint: 'Îndreptați camera spre codul de bare. Valoarea este completată automat odată detectată.',
    },
    file: {
      uploadFailed: 'Încărcare eșuată',
      uploadError: 'Fișierul nu a putut fi încărcat.',
      remove: 'Elimină {{name}}',
      attach: 'Atașează fișier',
      download: 'Descarcă {{name}}',
      preview: 'Vezi {{name}}',
      previewFailed: 'Previzualizare eșuată',
      previewError: 'Fișierul nu a putut fi deschis.',
      downloadFailed: 'Descărcare eșuată',
      downloadError: 'Fișierul nu a putut fi descărcat.',
      maxReached: 'S-a atins numărul maxim de {{max}} fișier(e).',
      uploadsUnavailable: 'Încărcarea fișierelor nu este disponibilă aici.',
    },
  },
  platform: {
    createTenant: 'Creează organizație',
    colName: 'Nume',
    colSlug: 'Slug',
    colStatus: 'Stare',
    colCreated: 'Creat',
    colUpdated: 'Actualizat',
    suspend: 'Suspendă',
    reactivate: 'Reactivează',
    delete: 'Șterge…',
    confirmDelete: 'Arhivezi și programezi ștergerea „{{name}}”?',
    createTenantModalTitle: 'Creează o organizație',
    slugDescription: 'Litere mici, cifre și cratime',
    form: 'formular',
    service: 'serviciu',
    forms: 'formulare',
    services: 'servicii',
    catalogAlert:
      'Valorile implicite ale platformei sunt vizibile doar pentru citire în fiecare organizație. Creează-le și publică-le aici, apoi <b>aprovizionează</b> o valoare implicită publicată în organizațiile selectate ca un {{kind}} editabil.',
    newDefault: '{{kind}} implicit nou',
    provisionToTenants: 'Aprovizionează către organizații',
    noDefaults: 'Nu există încă {{kind}} implicite pe platformă — creează unul pentru a începe.',
    createAndOpenBuilder: 'Creează și deschide editorul',
    provisionModalTitle: 'Aprovizionează „{{name}}”',
    targetTenants: 'Organizații țintă',
    provision: 'Aprovizionează',
    provisionedTitle: 'Aprovizionat',
    provisionedMessage: '{{name}} copiat în {{count}} organizație/organizații.',
    catalogTitle: 'Catalog implicit al platformei',
    tabForms: 'Formulare implicite',
    tabServices: 'Servicii implicite',
    allTenants: 'Toate organizațiile',
    actionPrefix: 'Prefix acțiune',
  },
  search: {
    title: 'Căutare',
    placeholder: 'Căutați servicii, răspunsuri trimise și conținutul documentelor…',
    all: 'Toate',
    services: 'Servicii',
    submissions: 'Trimiteri',
    documents: 'Documente',
    typeService: 'Serviciu',
    typeSubmission: 'Trimitere',
    typeDocument: 'Document',
    untitled: '(fără titlu)',
    noResults: 'Niciun rezultat pentru „{{query}}”.',
  },
  comments: {
    title: 'Comentarii',
    empty: 'Niciun comentariu încă.',
    placeholder: 'Scrie un comentariu…',
    post: 'Publică comentariul',
    posted: 'Comentariu publicat',
    delete: 'Șterge comentariul',
  },
  import: {
    title: 'Importă un serviciu',
    subtitle: 'Creează un serviciu complet și formularele sale dintr-un singur fișier JSON — generează-l cu AI, apoi importă-l.',
    aiTitle: 'Generează cu AI',
    aiHelp: 'Copiază acest prompt în Claude, descrie serviciul de care ai nevoie și lipește JSON-ul returnat mai jos.',
    copyPrompt: 'Copiază promptul',
    promptCopied: 'Prompt copiat în clipboard',
    jsonTitle: 'Importă JSON',
    jsonPlaceholder: 'Lipește JSON-ul serviciului aici…',
    loadFile: 'Încarcă fișier .json',
    importButton: 'Importă serviciul',
    invalidJson: 'JSON-ul nu a putut fi interpretat. Verifică formatul și încearcă din nou.',
    success: 'Serviciu importat ca ciornă — verifică-l și publică-l.',
  },
};
